import { TemplateRef } from '@angular/core';

export interface TimeOptions {
  allowTimePicker?: boolean;
  timePickerComponent?: TemplateRef<any>;
  withoutTimeZone?: boolean;
}
